export default __webpack_public_path__ + "static/media/box-technologies@2x.6f35fcd5.png";